import { render, staticRenderFns } from "./EditAssignmentAnswer.vue?vue&type=template&id=05ce94ed"
import script from "@/services/assignment/answer/edit-assignment-answer.js?vue&type=script&lang=js&external"
export * from "@/services/assignment/answer/edit-assignment-answer.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports